import qs from "qs";
import { GetServerSideProps } from "next";
// import ServicesInnerPage from "@/Components/pages/Services-inner";
import AiConsulting from "@/Components/pages/ai-consulting";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  const slug = ctx.params?.slug as string;
  const subSlug = ctx.params?.subSlug as string;

  const userAgent = ctx.req.headers["user-agent"] || "";
  const isMobile =
    /iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/i.test(
      userAgent,
    );

  if (subSlug === "services") {
    return {
      redirect: {
        permanent: true,
        destination: "/services",
      },
    };
  }

  if (
    ![
      "ai-services",
      "enterprise-platforms-solutions",
      "software-services",
    ].includes(slug)
  ) {
    return {
      redirect: {
        permanent: true,
        destination: "/services/",
      },
    };
  }

  const query = qs.stringify(
    {
      filters: {
        slug: {
          $eq: subSlug,
        },
      },
      populate: "deep, 10",
    },
    { encodeValuesOnly: false },
  );

  const apiRes = await fetch(
    `${baseUrl}services-page-v2s?${decodeURIComponent(query)}`,
  );
  let apiResData = await apiRes.json();

  const listData = apiResData?.data;

  if (!listData.length) {
    return {
      notFound: true,
    };
  }

  apiResData = listData;

  return {
    props: {
      apiResData,
      slug,
      subSlug,
      isMobile,
    },
  };
};

interface ServiceProps {
  apiResData: any;
  slug: string;
  subSlug: string;
  isMobile?: boolean;
}

const ChildService: React.FC<ServiceProps> = ({ apiResData, isMobile }) => {
  const data = apiResData[0].attributes;

  const blocksData = data?.blocks ?? null;
  const seoData = data?.seo ?? null;
  const parent = data?.parent ?? null;
  const breadcrumbs = data?.breadcrumbs ?? null;

  let pageContent;

  switch (data?.template) {
    case "ChildService":
      pageContent = (
        <AiConsulting
          blocks={blocksData}
          seo={seoData}
          isMobile={!!isMobile}
          parent={parent}
          breadcrumbs={breadcrumbs}
        />
      );
      break;
    // case "CRM Services Pages":
    //   pageContent = <>CRM Services Pages</>;
    //   break;
    // case "Software Service Pages":
    //   pageContent = <>Software Service Pages</>;
    //   break;
    // default:
    //   pageContent = (
    //     <ServicesInnerPage
    //       slug={slug}
    //       data={apiResData}
    //       isMobile={!!isMobile}
    //     />
    //   );
  }

  return <div id="root">{pageContent}</div>;
};

export default ChildService;
